const AgeGateModal = {
    init: function () {
        this.initAgeGateModal()
    },

    initAgeGateModal: function () {
        let cookieDaysLifeTime = 45;
        let cookiePopup = document.querySelector('[data-age-gate-modal-js]');
        let acceptBtn = document.querySelector('[data-age-gate-accept-js]');

        if (!cookiePopup || !acceptBtn) return;

        let cookieVal = getCookie('ageConfirmed');

        if (cookieVal !== 'confirmed') {
            cookiePopup.classList.add('is-active');
        }

        acceptBtn.addEventListener('click', function () {
            setCookie('ageConfirmed', 'confirmed', cookieDaysLifeTime);
            cookiePopup.classList.remove('is-active');
        });

        function getCookie(name) {
            let value = "; " + document.cookie;
            let parts = value.split("; " + name + "=");
            if (parts.length === 2) return parts.pop().split(";").shift();
        }

        function setCookie(name, value, days) {
            var d = new Date;
            d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
            document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
        }
    }
};

export default AgeGateModal;